import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Login from './Login';
import MapaFlota from './MapaFlota';
import MapaObjetivos from './MapaObjetivos';

axios.defaults.withCredentials = true;

export default function App() {
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [tab, setTab] = useState('flota');

  useEffect(() => {
    axios.get('/api/v1/auth/me')
      .then(r => { setUsuario(r.data); setCargando(false); })
      .catch(() => { setUsuario(null); setCargando(false); });
  }, []);

  // Heartbeat: refresca datos del usuario cada 2 minutos
  useEffect(() => {
    if (!usuario) return;
    const iv = setInterval(() => {
      axios.get('/api/v1/auth/me')
        .then(r => setUsuario(r.data))
        .catch(() => setUsuario(null));
    }, 120000);
    return () => clearInterval(iv);
  }, [usuario]);

  const handleLogout = async () => {
    try { await axios.post('/api/v1/auth/logout'); } catch (_) {}
    setUsuario(null);
  };

  if (cargando) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center',
                  height:'100vh', color:'#8892a4', flexDirection:'column', gap:12 }}>
      <div style={{ fontSize:32 }}>📍</div>
      <div>Cargando GPS Tracking...</div>
    </div>
  );

  if (!usuario) return <Login onLogin={setUsuario} />;

  return (
    <div style={{ display:'flex', flexDirection:'column', height:'100vh' }}>
      {/* Header */}
      <header style={{
        background:'#0b132b', borderBottom:'1px solid #1c2541',
        padding:'10px 20px', display:'flex', alignItems:'center', gap:16, flexShrink:0
      }}>
        <img src="/logo.png" alt="ZLinkINT" style={{ height:24, width:24, objectFit:'cover', borderRadius:6 }} />
        <span style={{ fontWeight:700, color:'#00c8ff', letterSpacing:1 }}>GPS TRACKING</span>
        <span style={{ color:'#1c2541' }}>|</span>
        <span style={{ color:'#8892a4', fontSize:12 }}>ZlinkINT</span>

        {/* Tabs */}
        <div style={{ display:'flex', gap:4, marginLeft:16 }}>
          {[
            { id:'flota', label:'🚗 Control de Flota' },
            { id:'objetivos', label:'🎯 Seguimiento Objetivos' },
          ].map(t => (
            <button key={t.id} onClick={() => setTab(t.id)}
              style={{
                padding:'6px 14px', border:'none', borderRadius:6, cursor:'pointer',
                fontSize:13, fontWeight:600,
                background: tab === t.id ? '#ff6600' : 'transparent',
                color: tab === t.id ? '#fff' : '#8892a4',
                borderBottom: tab === t.id ? '2px solid #ff6600' : '2px solid transparent',
              }}>
              {t.label}
            </button>
          ))}
        </div>

        {/* Info usuario */}
        <div style={{ marginLeft:'auto', display:'flex', alignItems:'center', gap:12 }}>
          {usuario.es_admin && (
            <span style={{
              background:'#431407', color:'#ff6600',
              padding:'2px 8px', borderRadius:12, fontSize:11, fontWeight:700
            }}>ADMIN</span>
          )}
          <span style={{ color:'#8892a4', fontSize:12 }}>
            {usuario.nombre || usuario.username}
          </span>
          <span style={{
            background:'#082f49', color:'#00c8ff',
            padding:'2px 8px', borderRadius:12, fontSize:11, fontWeight:700
          }}>
            {usuario.tokens_gps} créditos
          </span>
          <button onClick={handleLogout} style={{
            background:'transparent', border:'1px solid #1c2541', color:'#8892a4',
            padding:'4px 10px', borderRadius:6, cursor:'pointer', fontSize:12
          }}>Salir</button>
        </div>
      </header>

      {/* Contenido */}
      <main style={{ flex:1, overflow:'hidden' }}>
        {tab === 'flota'     && <MapaFlota usuario={usuario} />}
        {tab === 'objetivos' && <MapaObjetivos usuario={usuario} onUsuarioActualizado={setUsuario} />}
      </main>
    </div>
  );
}
